module.exports = __webpack_public_path__ + "img/logout-confirmation-illustration.8ca6803c.svg";